/**
 * ClearButton — "Clear all" filter reset button.
 * Extracted from FilterBar.jsx to reduce duplication between desktop/mobile paths.
 */
import { X } from 'lucide-react';
import { useT } from '../../../lib/i18n/I18nContext';

export default function ClearButton({ onClick, fullWidth = false, label }) {
  const { t } = useT();
  return (
    <button
      onClick={onClick}
      style={{
        background: 'none',
        border: '1px solid var(--bdr)',
        borderRadius: 8,
        padding: '6px 10px',
        fontSize: 12,
        color: 'var(--tm)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        minHeight: 44,
        width: fullWidth ? '100%' : undefined,
        justifyContent: fullWidth ? 'center' : undefined,
      }}
    >
      <X size={12} strokeWidth={1.5} />
      {label || t('common.clearAll')}
    </button>
  );
}
